import { render } from "./InteractiveGraphic.vue?vue&type=template&id=4856c05e"
import script from "./InteractiveGraphic.vue?vue&type=script&lang=js"
export * from "./InteractiveGraphic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__